import * as Sentry from '@sentry/react';
import { FeatureFlag, checkFeatureFlag } from 'hooks/useFeatureFlag';
import { getSentryEnvironment } from 'util/env';

export const initializeSentry = () => {
  const enableFeedback = checkFeatureFlag(FeatureFlag.ENABLE_FEEDBACK);

  const integrations: NonNullable<
    Parameters<typeof Sentry.init>[0]['integrations']
  > = [
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    Sentry.replayCanvasIntegration(),
    Sentry.browserTracingIntegration(),
  ];

  if (enableFeedback) {
    integrations.push(
      Sentry.feedbackIntegration({
        colorScheme: 'system',
        showBranding: false,
      }),
    );
  }

  Sentry.init({
    dsn: 'https://e14dcf2851ea739574f10f7a275ed148@o4510068029849600.ingest.de.sentry.io/4510073361203280',
    sendDefaultPii: true,
    integrations,
    enableLogs: true,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: getSentryEnvironment(),
    release: import.meta.env.VITE_SENTRY_RELEASE ?? 'unknown-plant-designer',
  });
};
